var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestoneHero4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 403,
    viewBox: "0 0 255 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.868 190.372C277.827 137.757 236.672 98.8344 187.865 92.3957C150.032 87.4028 96.0931 100.406 74.8422 145.902C54.9929 188.395 73.7489 237.642 102.323 262.979C144.391 300.292 220.971 297.485 276.62 245.75C277.965 251.065 286.49 282.482 317.607 298.818C337.954 309.499 357.354 308.176 365.155 307.2C359.379 294.487 349.617 268.468 351.644 234.7C354.023 195.306 371.114 167.582 379.186 156.067C371.316 154.444 360.451 153.286 347.947 155.341C315.706 160.617 296.492 183.227 290.873 190.395L290.868 190.372Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.36 156.232C65.7114 139.318 82.9501 129.135 99.8637 133.486C116.777 137.838 126.961 155.076 122.609 171.99L121.188 177.515C116.837 194.428 99.5979 204.612 82.6844 200.26C65.7708 195.909 55.5872 178.67 59.9387 161.757L61.36 156.232Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 183.766C64.8861 181.807 60.971 171.446 63.7553 160.623C66.5397 149.801 74.9691 142.615 82.583 144.574C90.1969 146.533 94.112 156.894 91.3277 167.717C88.5434 178.539 80.1139 185.725 72.5 183.766Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6399 190.876L74.3663 174.027L91.5954 181.606L75.6399 190.876Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4578 150.472C65.007 147.486 69.3377 140.182 78.1264 135.999C89.3131 130.677 104.378 132.036 114.279 141.873C126.442 153.962 122.851 170.915 122.609 171.981C102.89 164.804 83.1791 157.639 63.4604 150.461L63.4578 150.472Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.642 168.847C117.994 151.934 135.232 141.75 152.146 146.102C169.059 150.453 179.243 167.692 174.892 184.605L173.47 190.13C169.119 207.043 151.88 217.227 134.967 212.875C118.053 208.524 107.869 191.285 112.221 174.372L113.642 168.847Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.782 196.392C117.168 194.433 113.253 184.072 116.037 173.249C118.821 162.427 127.251 155.241 134.865 157.2C142.479 159.159 146.394 169.52 143.609 180.343C140.825 191.165 132.396 198.351 124.782 196.392Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.922 203.492L126.648 186.644L143.877 194.222L127.922 203.492Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.74 163.096C117.289 160.11 121.619 152.806 130.408 148.624C141.595 143.301 156.66 144.66 166.561 154.497C178.724 166.586 175.132 183.539 174.891 184.605C155.172 177.428 135.461 170.263 115.742 163.085L115.74 163.096Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M172.612 141.414L150.208 131.398C144.911 129.03 142.536 122.816 144.904 117.52L144.909 117.51C147.277 112.213 153.49 109.839 158.787 112.207L181.191 122.223C186.488 124.591 188.863 130.805 186.495 136.102L186.49 136.111C184.122 141.408 177.909 143.782 172.612 141.414Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6976 98.0196L106.154 100.059C111.936 100.542 116.232 105.62 115.75 111.402L115.749 111.412C115.267 117.194 110.189 121.491 104.407 121.008L79.9502 118.969C74.1682 118.486 69.8719 113.408 70.3542 107.626L70.3551 107.616C70.8373 101.834 75.9155 97.5373 81.6976 98.0196Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.996 214.508C100.488 210.785 92.4197 210.185 90.7687 213.144C89.2236 215.904 93.5521 221.215 95.5925 223.53C91.7549 226.177 89.0262 229.868 89.684 232.793C90.5515 236.715 97.7053 240.237 106.931 237.729",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M204.538 186.917C222.231 199.442 239.913 211.964 257.602 224.499C251.466 233.172 244.658 237.202 240.451 239.135C222.085 247.569 197.888 241.397 178.839 223.859",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.546 232.218C246.175 231.854 196.181 200.345 196.181 200.345",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M228.3 241.337L184.992 212.936",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.619 95.2182C181.001 84.9241 181.392 74.6327 181.776 64.3284C214.525 59.6065 245.589 72.9897 260.233 97.867C272.255 118.306 269.158 139.66 267.771 146.864",
    fill: "#5B5BD8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.619 95.2182C181.001 84.9241 181.392 74.6327 181.776 64.3284C214.525 59.6065 245.589 72.9897 260.233 97.867C272.255 118.306 269.158 139.66 267.771 146.864",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.052 66.9632C207.585 78.4424 206.118 89.9215 204.651 101.401L209.052 66.9632Z",
    fill: "#5B5BD8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M209.052 66.9632C207.585 78.4424 206.118 89.9215 204.651 101.401",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M255.679 94.0687C254.212 105.548 252.744 117.027 251.277 128.506L255.679 94.0687Z",
    fill: "#5B5BD8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M255.679 94.0687C254.212 105.548 252.744 117.027 251.277 128.506",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M233.711 75.2611C232.244 86.7402 230.777 98.2193 229.31 109.698L233.711 75.2611Z",
    fill: "#5B5BD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M233.711 75.2611C232.244 86.7402 230.777 98.2193 229.31 109.698",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneHero4);
export default __webpack_public_path__ + "static/media/milestone-hero4.6a2727e09f2f52c475734063470f0a8e.svg";
export { ForwardRef as ReactComponent };